import { useState } from "react";

export function useAdaptTableData() {
  const setPlanStatus = (status) => {
    return {
      0: { text: "Suspenso", color: "warning" },
      1: { text: "Ativo", color: "info" },
      2: { text: "Expirado", color: "danger" },
      3: { text: "Aguardando ativação", color: "warning" },
    }[status];
  };

  return [setPlanStatus];
}



// WEBPACK FOOTER //
// ./src/views/AppViews/Plans/hooks/index.jsx